<template>
  <section>
    <el-row class="warp">
        <el-col :span="6" class="warp-breadcrum">
            <el-breadcrumb separator="/">
            <!--
                <el-breadcrumb-item :to="{ path: '/' }">
                <b>首页</b>
                </el-breadcrumb-item>
            -->
                <el-breadcrumb-item>单篇数据上传列表</el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
    </el-row>  

      <!--工具条 begin-->
    <el-row class="warp">
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item>
                    <el-button size="mini" type="primary" @click="creatIndividualTask(null)">创建单篇任务</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" type="primary" @click="refresh(null)">刷新</el-button>
                </el-form-item>
            </el-form>
        </el-col>
      <!--工具条 end-->

      <!-- 列表显示 begin-->
        <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
            <el-table :data="individualTasks" style="width: 100%;overflow: auto;" stripe highlight-current-row v-loading="tableLoading" class="tablebar">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="left" inline class="demo-table-expand">
                      <el-form-item label="源文件：">
                        <span>{{ props.row.unProcessFileName }}</span>
                      </el-form-item>
                      <el-form-item label="源文件路径：">
                        <span>{{ props.row.unProcessFilePath }}</span>
                      </el-form-item>
                      <el-form-item label="加工文件：">
                        <span>{{ props.row.processedFileName }}</span>
                      </el-form-item>
                      <el-form-item label="加工文件路径：">
                        <span>{{ props.row.processedFilePath }}</span>
                      </el-form-item>
                      <el-form-item label="任务创建用户：">
                        <span>{{ props.row.createUser }}</span>
                      </el-form-item>
                      <el-form-item label="任务加工用户：">
                        <span>{{ props.row.processedUser }}</span>
                      </el-form-item>
                      <el-form-item label="源文件下载时间：">
                        <span>{{ props.row.downloadTime }}</span>
                      </el-form-item>
                      <el-form-item label="加工文件上传时间：">
                        <span>{{ props.row.finishTime }}</span>
                      </el-form-item>
                      <el-form-item label="doi:">
                        <span>{{ props.row.doi }}</span>
                      </el-form-item>
                      <el-form-item label="issn:">
                        <span>{{ props.row.issn }}</span>
                      </el-form-item>
                      <el-form-item label="volume:">
                        <span>{{ props.row.volume }}</span>
                      </el-form-item>
                      <el-form-item label="issue:">
                        <span>{{ props.row.issue }}</span>
                      </el-form-item>
                  </el-form>
                </template>
            </el-table-column>
            <!-- 第一行显示数据 -->
                <!-- <el-table-column
                    width="50">
                </el-table-column> -->
                <el-table-column prop="createUser" label="创建用户" sortable align="center"></el-table-column>
                <el-table-column prop="doi" label="文章DOI" width="210" sortable align="center">
                    <template slot-scope="scope">
                        <span class="span-text" v-if="scope.row.pubUrl!== undefined"><a link :href="scope.row.pubUrl" target="_blank">{{ scope.row.doi }}</a></span>
                    </template>
                </el-table-column>
                <el-table-column prop="unProcessFileName" label="稿号" sortable align="center"></el-table-column>
                <el-table-column prop="journalName" label="期刊" sortable align="center"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable align="center"></el-table-column>
                <el-table-column prop="dataType" label="数据类型" sortable align="center"></el-table-column>
                <el-table-column prop="status" label="任务状态" sortable align="center">
                    <template slot-scope="scope">
                        <el-tag
                            :type="scope.row.status === 2 || scope.row.status === 4 ? 'success' : 'danger'"
                            disable-transitions>
                            {{scope.row.statusInfo}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="上传" width="120" align="center">
                    <template slot-scope="scope">
                        <el-upload
                        class="upload-demo"
                        :ref="uploadDemo + scope.$index"
                        :action="packageUrl(flag,scope.row)"
                        :limit="1"
                        :file-list="fileList"
                        :on-success="uploadApkSuccess"
                        :before-upload="beforeUpload"
                        :auto-upload="false"
                        :on-change="changeFile"
                        >
                            <el-button size="small" type="success" @click="uploadClick(scope.$index)" :style="(scope.row.status === 0) ? { display: '' } : { display: 'none' }">点击上传</el-button>
                        </el-upload>
                    </template>
                </el-table-column>
                <!-- 操作按钮 -->
                <el-table-column label="操作" width="120" align="center">
                    <template slot-scope="scope">
                        <el-button size="small" type="danger" @click="deleteTask(scope.row)" :style="(scope.row.status === 3 || scope.row.status ===4 || scope.row.status ===5) ? { display: 'none' } : { display: '' }" >删除任务</el-button>
                    </template>
                </el-table-column>
                <div slot="empty" class="empty">
                  <el-empty description="暂无数据"></el-empty>
                </div>
            </el-table>
        </el-col>
      <!-- 列表显示 end-->
      <!--底部分页-->
        <el-col :span="24" class="foolbar">
            <!-- hide-on-single-page  -->
            <el-pagination 
                background 
                layout="total, sizes, prev, pager, next"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pageSize"
                :page-sizes = pageSizes
                :total="total" 
                hide-on-single-page 
                style="float:right;">
            </el-pagination>
        </el-col>

        <!--新增对话框界面 begin-->
        <el-dialog title="单篇任务创建" :visible.sync="addFormVisible" :close-on-click-modal="false" v-loading="createLoading" element-loading-text="创建中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
                <!-- 创建form -->
                <el-form-item label="文章DOI:" prop="doi">
                    <el-input v-model="addForm.doi" placeholder="请在此输入文章的DOI"></el-input>
                </el-form-item>
                <el-form-item label="期刊issn:" prop="issn">
                    <el-select v-model="addForm.issn" filterable placeholder="请选择期刊">
                        <el-option
                          v-for="item in journalList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据类型:" prop="type">
                    <el-select v-model="addForm.type" placeholder="请选择数据类型">
                        <el-option
                        v-for="item in dataTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卷:" prop="volume">
                    <el-input v-model="addForm.volume" placeholder="请在此输入文章卷号"></el-input>
                </el-form-item>
                <el-form-item label="期:" prop="issue">
                    <el-input v-model="addForm.issue" placeholder="请在此输入文章期号"></el-input>
                </el-form-item>
            </el-form>
            <!-- 创建form -->
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>
    <!-- 新增对话框界面 end -->
    </el-row>
  </section>
</template>

<script>
import API_INDIVIDUAL from "../../../api/api_individual";
import API_JOURNAL from "../../../api/api_journal";

export default {
  data() {
    return {
        createLoading:false,
        addFormVisible: false, //新增界面是否显示
        addLoading: false, //新增界面加载状态
        addFormRules: {
            doi: [
                { required: true, message: "请输入文章的DOI", trigger: "blur" }
            ],
            issn:[
                { required: true, message: "请选择期刊的issn", trigger: "blur" }
            ],
            type:[
                { required: true, message: "请数据类型", trigger: "blur" }
            ]
        },
        addForm: {
            doi: "",
            issn: "",
            type:"",
            volume: "",
            issue:"",
        },
        flag: '',
        uploadDemo:"uploadDemo",
        uploadName:"",
        individualTasks: [],
        //页码
        page: 1,
        //每页数量
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        //总数
        total: 0,
        clientHeight: window.innerHeight - 258,
        //页面载入状态
        tableLoading: false,
        fileList: [],
        //在此添加新的数据定义
        dataTypeOptions: [
            {
                value: 'normal',
                label: '正式出版'
            }, 
            {
                value: 'online_first',
                label: '优先出版'
            }
        ],
        journalList:[],
    };
  },

  methods: {
    findAllIndividualTasks(){
        let that = this;
        this.tableLoading = true
        let params = {
            page: that.page,
            pageSize: that.pageSize,
        };
        API_INDIVIDUAL.getAllIndividualTasks(params)
        .then(res=>{
            if(res && res.individualTasks){
            that.individualTasks = Object.values(res.individualTasks);
            that.total = res.total;
            console.log(
                "......findAllIndividualTasks:" + JSON.stringify(that.individualTasks)
                );
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求出现异常",
            duration:2000
            });
        }).finally(()=>{
          this.tableLoading = false
        });;
    },

    creatIndividualTask(){
        let that = this;
        that.findJournalList();
        that.addFormVisible = true;
    },

    findJournalList(){
        let that = this;
        API_JOURNAL.getJournalListTree()
        .then(res=>{
            if(res && res.journal){
            that.journalList = Object.values(res.journal);
            console.log(
                "......findJournalList:" + JSON.stringify(that.journalList)
                );
            }
        })
        .catch(e=>{
            this.$message({
            showClose:true,
            type:"error",
            message:"请求出现异常",
            duration:2000
            });
        });
    },

    //新增提交
    addSubmit: function() {
        let that = this;
        if (that.addLoading) return;
        that.$refs.addForm.validate(valid => {
            if (valid) {
            let params = {
                doi: that.addForm.doi,
                issn: that.addForm.issn,
                issue: that.addForm.issue,
                volume: that.addForm.volume,
                type: that.addForm.type,
            };

            that.createLoading = true;

            console.log(
                ".........individualTask create by params:" + JSON.stringify(params)
            );

            //发送http请求
            API_INDIVIDUAL.addIndividualTask(params)
                .then(res => {
                if (0 === res.errorCode) {
                    that.$message({
                    type: "success",
                    message: "创建成功!"
                    });

                    //创建成功后，刷新列表显示
                    this.refresh();
                } else {
                    that.$message({
                    showClose: true,
                    message: res.errorInfo,
                    type: "error"
                    });
                }
                that.$refs["addForm"].resetFields(); //清空数据
                that.addFormVisible = false;
                that.createLoading = false;
                })
                .catch(e => {
                that.$message({
                    showClose: true,
                    type: "error",
                    message: "请求出现异常",
                    duration: 2000
                });
                that.$refs["addForm"].resetFields(); //清空数据
                that.addFormVisible = false;
                that.createLoading = false;
                });
            } else {
            that.$message({
                showClose: true,
                type: "error",
                message: "请正确填写信息！",
                duration: 2000
            });
            }
        });
    },

    deleteTask(row){
      this.$confirm("此操作将永久删除任务及上传文件，是否继续？","提示",{
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(()=>{
        this.deleteIndividualTask(row.id);
        let that = this;
        let params = {
          id: row.id,
        };
        API_INDIVIDUAL.deleteIndividualTask(params)
        .then(res => {
            if(res && res.errorCode === 0){
              this.$message({
                type: "success",
                message: "删除成功!"
              });
              that.refresh();
            }
            else{
              that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
              });
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求deleteIndividualTask出现异常",
            duration: 2000
          });
        });
      })
      .catch(()=>{
        this.$message({
            type: "info",
            message: "已取消删除"
          });
      });
    },

    deleteIndividualTask(id){
      let that = this;
      let params = {
        id: id,
      };
      //console.log("......getErrorDetailByPrimaryId params:" + JSON.stringify(params));
      //发送http请求
      API_INDIVIDUAL.deleteIndividualTask(params)
        .then(res => {
            if(res && res.errorCode === 0){
                that.refresh();
            }
            else{
              that.$message({
                  showClose: true,
                  message: res.errorInfo,
                  type: "error"
                });
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求deleteIndividualTask出现异常",
            duration: 2000
          });
        });
    },

    packageUrl(flag,row)
    {
      //debugger;
      flag = '4';
      return  "api/individualTask/fileUpload?flag="+flag+"&id="+row.id;
    },

    changeFile(file){
      if(file.status == 'ready'){
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('span', null, '请确定是否上传?'),
            //('i', { style: 'color: red' }, this.selectedLabel),
            //h('span',null,' 类型的文件?')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.submitUpload();
        }).catch(() => {
            this.$refs[`${this.uploadName}`].clearFiles();
            this.$message({
              type: 'info',
              message: '取消文件上传'
            });
        });
      }
    },

    uploadClick(index){
      console.log("uploadClick index:"+index);
      console.log("uploadClick refs",this.$refs);
      this.uploadName = "uploadDemo"+index;
    },

    submitUpload() {
      console.log(this.$refs[`${this.uploadName}`]);
      console.log("submitUpload:" + this.uploadName);
      
      this.$refs[`${this.uploadName}`].submit();
    },

    beforeUpload(){
      this.tableLoading = true;  
    },

    uploadApkSuccess(response, fileList) {
      //console.log('response ----> ',response);
      //console.log('fileList ----> ',fileList);
      if(response.errorCode != 0)
      {
          this.$message({
          showClose: true,
          type: "info",
          message: response.errorInfo,
          duration: 2000
        });
        this.fileList= [];
        this.tableLoading = false;
        return;
      }
      else{
        this.fileList= [];
        this.tableLoading = false;
        this.refresh();
      }
    },

    getRows: function(_page) {
        this.page = _page;
        this.findAllIndividualTasks();
    },

    handleSizeChange(val) {
        this.pageSize = val;
        this.findAllIndividualTasks();
    },

    //分页选择处理
    handleCurrentChange: function(val) {
      this.getRows(val);
    },

    //初始化表格高度
    initHeight: function() {
      this.clientHeight = (document.documentElement.clientHeight - 258) + 'px';
    },

    refresh(){
      //点击查询按钮，分页初始化为1
      let _page = 1;
      //重新搜索时进行重置
      this.total = 0;
      //查询前清除查询列表信息
      this.individualTasks = null;
      //进行分页查询
      this.getRows(_page);
    },

  },
  mounted() {
    window.addEventListener('resize', this.initHeight);
    this.initHeight();
    this.findAllIndividualTasks();
  },
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/Data/IndividualUpload.vue